/**
 * makes a URL have an absolute form (http:// or https://) so it can be used
 * safely as an href. If the value has no scheme, prepends https://
 */
export function ensureAbsoluteUrl(url) {
  if (url == null || typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}
